<template>
  <div class="pg-popover-wrapper">
    <h3>Potwierdź umowę</h3>

    <div class="inner-padding" style="padding: 0 30px">
      <form class="form form-resend-token" @submit.prevent="postConfirm" style="margin-bottom: 15px">
        <div class="form-group">
          <label>Token:</label>
          <div class="input-wrapper">
            <input v-model="form.sms_token"
                   type="number"
                   :class="{'input-error' : errors.sms_token }"
                   placeholder="Podaj kod SMS"
                   ref="smsTokenInput"
                   required/>
          </div>
          <p class="error" v-if="errors.sms_token">{{ errors.sms_token[0] }}</p>
        </div>
        <ion-button mode="ios" size="medium" fill="outline" type="submit" :disabled="loading">
          <span v-if="loading"><span class="loader"></span></span>
          <span v-else>Zapisz</span>
        </ion-button>
      </form>
    </div>

  </div>
</template>

<script>
  // this component has no access to store via import
  // instead pass store as props
  export default {
    name: 'ConfirmTokenPopover',
    props: ['store','route','uuid','ph_slug'],
    data() {
      return {
        loading: false,
        form: {
          sms_token : '',
        }
      }
    },
    computed: {
      errors(){
        return this.store.state.loyalty.errors
      }
    },
    mounted() {

    },
    methods: {
      postConfirm(){
        let payload = { 'sms_token' : this.form.sms_token, 'uuid' : this.uuid }
        this.store.dispatch('loyalty/LOYALTY_CONTRACT_CONFIRM_REQUEST', payload).then(resp => {
          // close popover on success
          this.dismissPopover()
          // and refresh client details
          let payload = {'ph_slug': this.ph_slug, 'client_slug': this.route.params.slug}; // TODO test this
          this.store.dispatch('clients/PH_CLIENTS_DETAILS_REQUEST', payload)
        })
      },
      dismissPopover() {
        return this.$ionic.popoverController.dismiss()
      }
    }
  }
</script>